import { faMagnifyingGlassChart } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { RouteObject } from 'react-router-dom';
import { DeepDiveWidget, WidgetHost } from '@/core/widgets/export';
import { Permissions } from '@/core/permissions/export';
import { selectApi } from '@/modules/calendar/api';
import DeepDiveLanding from '@/modules/calendar/components/data-deep-dive/deep-dive-landing';
import DeepDiveEvent from '@/modules/calendar/components/data-deep-dive/deep-dive-event';
import { HSC_WIDGET_ID } from '@/modules/calendar/widgets/hsc-widget-id';

export class HSCWidget implements DeepDiveWidget {
  get id(): string {
    return HSC_WIDGET_ID;
  }

  get defaultTitle(): string {
    return 'Data';
  }

  get headerPanel(): JSX.Element {
    return (
      <>
        <FontAwesomeIcon icon={faMagnifyingGlassChart} /> Data
      </>
    );
  }

  get icon(): React.ReactNode {
    return <FontAwesomeIcon icon={faMagnifyingGlassChart} />;
  }

  get routes(): RouteObject[] {
    return [
      {
        path: '/',
        element: <DeepDiveLanding />,
      },
      {
        path: '/event/:id',
        loader: async ({ params }) => {
          try {
            return await selectApi.getEvent(params.id || '');
          } catch (e) {
            return e;
          }
        },
        element: <DeepDiveEvent />,
      },
    ];
  }

  get defaultRoute(): string {
    return '/';
  }

  async hasPermission(permissions: string[]) {
    const hasSelect = permissions.some(value => Permissions.ANY_SELECT_PRODUCT.test(value));
    const hasExcel = permissions.includes(Permissions.EXCEL_PACKAGE);
    const hasHsc = permissions.includes(Permissions.HSC_PACKAGE);

    return (
      hasSelect && (!hasExcel || hasHsc) && permissions.includes(Permissions.ALPHA_ACCESS_DATA)
    );
  }

  shouldHideToUser(permissions: string[]): boolean {
    return !this.hasPermission(permissions);
  }

  initialize(host: WidgetHost): void {}
}

export const hscWidget = new HSCWidget();
